import { render, staticRenderFns } from "./CategoriaLista.vue?vue&type=template&id=0098986c&scoped=true&"
import script from "./CategoriaLista.vue?vue&type=script&lang=js&"
export * from "./CategoriaLista.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaLista.vue?vue&type=style&index=0&id=0098986c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0098986c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
